import React from 'react';
import { useLocale } from '../context/LocaleContext';
import { isPreviewLanguage } from '../i18n/languages';
import styles from '../styles/languageSwitcher.module.css';

/**
 * Language control for header — each language in its own name (English / Español).
 * Hidden when English is the only language this visitor can choose.
 */
const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale, selectableLanguages, t } = useLocale();

  if (selectableLanguages.length <= 1) return null;

  return (
    <label className={styles.wrap}>
      <span className={styles.visuallyHidden}>{t('i18n.switcher.aria')}</span>
      <select
        className={styles.select}
        value={locale}
        aria-label={t('i18n.switcher.aria')}
        title={t('i18n.switcher.label')}
        onChange={(e) => void setLocale(e.target.value)}
      >
        {selectableLanguages.map((lang) => (
          <option key={lang.code} value={lang.code} title={lang.name}>
            {isPreviewLanguage(lang.code)
              ? `${lang.nativeName} (${t('i18n.switcher.preview')})`
              : lang.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
